import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="py-16 border-t border-umber/10">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div>
            <div data-testid="footer-logo"><Logo /></div>
            <p className="mt-3 font-serif text-sm text-ink max-w-sm">
              Ein stiller Begleiter für die Worte, die zählen.
            </p>
          </div>
          <div>
            <p className="label-eyebrow mb-4 text-xs">Familie</p>
            <ul className="space-y-2 font-serif text-sm text-ink">
              <li><a href="/trauerrede-mutter" data-testid="footer-persona-mutter" className="hover:text-charcoal transition-colors">Für die Mutter</a></li>
              <li><a href="/trauerrede-vater" data-testid="footer-persona-vater" className="hover:text-charcoal transition-colors">Für den Vater</a></li>
              <li><a href="/trauerrede-mama" data-testid="footer-persona-mama" className="hover:text-charcoal transition-colors">Für Mama</a></li>
              <li><a href="/trauerrede-papa" data-testid="footer-persona-papa" className="hover:text-charcoal transition-colors">Für Papa</a></li>
              <li><a href="/trauerrede-oma" data-testid="footer-persona-oma" className="hover:text-charcoal transition-colors">Für die Oma</a></li>
              <li><a href="/trauerrede-opa" data-testid="footer-persona-opa" className="hover:text-charcoal transition-colors">Für den Opa</a></li>
              <li><a href="/trauerrede-tochter" data-testid="footer-persona-tochter" className="hover:text-charcoal transition-colors">Für die Tochter</a></li>
              <li><a href="/trauerrede-sohn" data-testid="footer-persona-sohn" className="hover:text-charcoal transition-colors">Für den Sohn</a></li>
            </ul>
          </div>
          <div>
            <p className="label-eyebrow mb-4 text-xs">Weitere</p>
            <ul className="space-y-2 font-serif text-sm text-ink">
              <li><a href="/trauerrede-ehepartner" data-testid="footer-persona-ehepartner" className="hover:text-charcoal transition-colors">Für den Ehepartner</a></li>
              <li><a href="/trauerrede-bruder" data-testid="footer-persona-bruder" className="hover:text-charcoal transition-colors">Für den Bruder</a></li>
              <li><a href="/trauerrede-schwester" data-testid="footer-persona-schwester" className="hover:text-charcoal transition-colors">Für die Schwester</a></li>
              <li><a href="/trauerrede-freund" data-testid="footer-persona-freund" className="hover:text-charcoal transition-colors">Für einen Freund</a></li>
              <li><a href="/trauerrede-kollege" data-testid="footer-persona-kollege" className="hover:text-charcoal transition-colors">Für Kolleg:innen</a></li>
              <li className="pt-3 border-t border-umber/10"><a href="/trauerrede-schreiben" data-testid="footer-guide-schreiben" className="hover:text-charcoal transition-colors">Trauerrede schreiben</a></li>
              <li><a href="/wie-lang-trauerrede" data-testid="footer-guide-wielang" className="hover:text-charcoal transition-colors">Wie lang darf sie sein?</a></li>
              <li><a href="/trauerrede-einleitung" data-testid="footer-guide-einleitung" className="hover:text-charcoal transition-colors">Die richtige Einleitung</a></li>
              <li><a href="/trauerrede-halten" data-testid="footer-guide-halten" className="hover:text-charcoal transition-colors">Eine Rede halten</a></li>
            </ul>
          </div>
          <div>
            <p className="label-eyebrow mb-4 text-xs">Rechtliches</p>
            <ul className="space-y-2 font-sans text-sm text-ink">
              <li><a href="/kontakt" data-testid="footer-kontakt" className="hover:text-charcoal transition-colors">Kontakt</a></li>
              <li><a href="/impressum" data-testid="footer-impressum" className="hover:text-charcoal transition-colors">Impressum</a></li>
              <li><a href="/datenschutz" data-testid="footer-datenschutz" className="hover:text-charcoal transition-colors">Datenschutz</a></li>
              <li><a href="/agb" data-testid="footer-agb" className="hover:text-charcoal transition-colors">AGB</a></li>
            </ul>
          </div>
        </div>
        <p className="font-sans text-xs text-ink/60 border-t border-umber/10 pt-6">
          © {new Date().getFullYear()} Oratiorede
        </p>
      </div>
    </footer>
  );
}
